/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-12-26 13:52:14
 * @modify date 2022-12-26 13:52:14
 * @desc 平台配置信息 小程序端 通过API 读取配置
 */
module.exports = {
  /**
   * @desc 首页配置信息
   */
  home: {
    /**
     * @desc 知名人物去世后 的 首页 背景灰色
     */
    eventGray: false,
    /**
     * @desc 智能推荐 模块名称
     */
    referralTitle: '智能推荐',
    /**
     * @desc 促销活动 模块名称
     */
    promotionTitle: '明星产品',
  },
};
